import React from 'react';
import PropTypes from 'prop-types';

import { Redirect, Route } from 'react-router-dom';

import store from 'store';
import { getIsLoggedIn } from 'store/services/session/selectors';

const ProtectedRoute = ({ component: Component, guards, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // We loop through guards and check
      // Most specific should always go last
      for (const guard of guards) {
        if (guard.getIsActive()) {
          return (
            <Redirect
              to={{
                pathname: guard.pathname,
                state: { from: props.location },
              }}
            />
          );
        }
      }

      return <Component {...props} />;
    }}
  />
);

ProtectedRoute.propTypes = {
  // React.lazy return an object so component could also be an object
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  guards: PropTypes.arrayOf(
    PropTypes.shape({
      getIsActive: PropTypes.func.isRequired,
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  ),
};

ProtectedRoute.defaultProps = {
  guards: [
    {
      getIsActive: () => getIsLoggedIn(store.getState()) === false,
      pathname: '/sign_in',
    },
  ],
};

export default ProtectedRoute;
